// extracted by mini-css-extract-plugin
export default {"priceNote":"UpdatePriceModal_priceNote__M+7ak","price":"UpdatePriceModal_price__q2loc"};